import { render, staticRenderFns } from "./inpatienttreatment.vue?vue&type=template&id=6f0a5923&"
import script from "./inpatienttreatment.vue?vue&type=script&lang=js&"
export * from "./inpatienttreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports